<!--page starts-->
 <section class="page-wrapper">
    <div class="player-single-top-section margin-top-152 cf">
    	<div class="container">
           <div class="player-single-top-detail cf">
              <div class="player-single-top-left cf">
                  <div class="player-single-image-detail">
                      <div class="player-single-image">
                          <img [src]="playerSingle?.image">
                      </div>
                      <!-- <div class="player-single-number">
                         <h3>{{playerSingle?.players_number}}</h3>
                      </div> -->
                  </div>
                  <div class="palyer-single-content-detail">
                      <div class="player-single-number-overlay">
                        <div class="player-single-number">
                           <h3>{{playerSingle?.players_number}}</h3>
                        </div>
                      </div>
                      <div class="palyer-single-content-inner">
                        <div class="player-single-vector-image">
                          <img src="assets/images/lccc-latest-new-fox-logo.png">
                        </div>
                        <h2>{{playerSingle?.first_name}}<span>{{playerSingle?.last_name}}</span></h2>
                        <h3>{{playerSingle?.designation}}</h3>
                        <div class="player-single-date-box">
                          <p>Date and Place of Birth</p>
                          <h4>{{playerSingle?.birth_date}}</h4>
                        </div>
                        <div class="player-single-season-box">
                          <p>{{ currentYear }} Season Sponsor</p>
                          <div class="player-single-season-image">
                             <a href="{{playerSingle?.sponsor_url}}" target="_blank"><img [src]="playerSingle?.sponsor_image"></a>
                          </div>
                      </div>
                     </div>
                  </div>
              </div>
              <div class="player-single-top-right">
                  <div class="player-single-top-content">
                      <p>{{playerSingle?.quote}}</p>
                  </div>
              </div>
           </div>
    	</div>
      <a [routerLink]="['/player-single', playerPrevious?.slug]" class="Previous-player" *ngIf="previous_data">
          <!-- <ul>
            <li class="player-img"><img [src]="playerPrevious?.image"></li>
            <li class="player-name">{{playerPrevious?.full_name}}</li>
          </ul> -->
      </a>
      <a [routerLink]="['/player-single', playerNext?.slug]" class="next-player" *ngIf="next_data">
          <!-- <ul>
            <li class="player-name">{{playerNext?.full_name}}</li>
            <li class="player-img"><img [src]="playerNext?.image"></li>
          </ul> -->
      </a>
	</div>
	<!-- <div class="player-single-center-section cf">
       <div class="container">
           <div class="player-single-center-detail-profile cf">
               <div class="player-single-join-box">
                   <p>Joined</p>
                   <h3>{{playerSingle?.joined_club}}</h3>
               </div>
               <div class="player-single-career-box">
                   <p>Playing Career</p>
                   <select>
                     <option *ngIf="playerSingle?.first_class_career">{{playerSingle?.first_class_career}}</option>
                     <option *ngIf="playerSingle?.one_day_career">{{playerSingle?.one_day_career}}</option>
                     <option *ngIf="playerSingle?.t20_career">{{playerSingle?.t20_career}}</option>
                   </select>
                   
               </div>
               <div class="player-single-season-box">
                   <p>2021 Season Sponsor</p>
                   <div class="player-single-season-image">
                      <a href="{{playerSingle?.sponsor_url}}" target="_blank"><img [src]="playerSingle?.sponsor_image"></a>
                   </div>
               </div>
               <div class="player-single-social-icon">
                   <ul>
                      <li *ngIf="playerSingle?.facebook_url"><a href="{{playerSingle?.facebook_url}}" target="_blank"><img src="assets/images/fb.svg"></a></li>
                      <li *ngIf="playerSingle?.instagram_url"><a href="{{playerSingle?.instagram_url}}" target="_blank"><img src="assets/images/insta.svg"></a></li>
                      <li *ngIf="playerSingle?.youtube_url"><a href="{{playerSingle?.youtube_url}}" target="_blank"><img src="assets/images/youtube.svg"></a></li>
                      <li *ngIf="playerSingle?.twitter_url"><a href="{{playerSingle?.twitter_url}}" target="_blank"><img src="assets/images/twi.svg"></a></li> 
                      <li *ngIf="playerSingle?.linkedin_url"><a href="{{playerSingle?.linkedin_url}}" target="_blank"><img src="assets/images/linkedin.svg"></a></li>
                   </ul>
               </div>
           </div>
           <div class="player-single-center-detail-stats cf">
               <div class="player-stats-career">
                   <p>First Class Career</p>
                   <h3>{{playerSingle?.first_class_career}}</h3>
               </div>
               <div class="player-oneday-career">
                   <p>One Day Career</p>
                   <h3>{{playerSingle?.one_day_career}}</h3>
               </div>
               <div class="player-t20-career">
                   <p>T20 Career</p>
                   <h3>{{playerSingle?.t20_career}}</h3>
               </div>
               <div class="player-retirement-date">
                   <p>Retirement Date</p>
                   <h3>{{playerSingle?.retirement_date}}</h3>
               </div>
               <div class="player-single-social-icon-stats">
                   <ul>
                      <li><a href="{{playerSingle?.facebook_url}}" target="_blank"><img src="assets/images/fb.svg"></a></li>
                      <li><a href="{{playerSingle?.instagram_url}}" target="_blank"><img src="assets/images/insta.svg"></a></li>
                      <li><a href="{{playerSingle?.youtube_url}}" target="_blank"><img src="assets/images/youtube.svg"></a></li>
                      <li><a href="{{playerSingle?.twitter_url}}" target="_blank"><img src="assets/images/twi.svg"></a></li> 
                      <li><a href="{{playerSingle?.linkedin_url}}" target="_blank"><img src="assets/images/linkedin.svg"></a></li>
                   </ul>
               </div>
           </div>
       </div>
	</div> -->
  <div class="player-single-bottom-section cf">
    <div class="container">
      <div class="player-single-bottom-detail cf">
        <div class="player-single-bottom-tab">
          <ul>
            <!-- <li class="courses-name active" id="profile"><a href="#">Profile</a></li> -->
            <!-- <li class="courses-name " id="stats"><a href="#">Status</a></li> -->
          </ul>
        </div> 
        <div class="player-single-bottom-tab-content course-main-content active cf" id="profile-content" [innerHTML]="playerSingle?.description">
          <p>Leicestershire CCC announced the appointment of Tom Smith as Second XI Coach in February 2018.</p>
          <p>Smith had a highly successful career as a player at Lancashire CCC, including winning County Championship Division One alongside Paul Horton in 2011, and being named as captain ahead of the 2015 season.</p>
          <p>The 32-year-old played alongside Nixon during a loan spell at Leicestershire CCC in 2008. The all-rounder made nine appearances in all competitions, scoring 290 runs at an average of 32.22 while also collecting 17 wickets.</p> 
          <p>Smith had great success in all formats throughout his career, scoring 7,720 runs and taking 376 wickets.</p>
          <p>He was sadly forced into an early playing retirement in 2016 and then forged a successful career in coaching, including spells with Lancashire Thunder in the Kia Super League and with England Women in preparation for their triumphant ICC World Cup campaign.</p>
          <p><a href="#">Tweets by @leicsccc</a></p>
        </div>
        <div class="player-single-bottom-tab-content course-main-content cf" id="stats-content">
          <div class="player-career-tab-section" *ngIf="playerSingle?.players_stats?.length > 1">
            <ul>
              <li class="career-name" id="tab-{{player?.players_stats_id}}"  [ngClass]="{ active: i == 0 }"*ngFor="let player of playerSingle?.players_stats; let i = index"><a href="#">{{player?.title}}</a></li>  
              <!-- <li class="career-name " id="test-cricket"><a href="#">Test Cricket</a></li>  
              <li class="career-name" id="one-day"><a href="#">One Day Internatioanl</a></li>   -->
            </ul>
          </div>
          <div class="player-career-tab-content career-main-content" [ngClass]="{ active: i == 0 }" id="tab-{{player?.players_stats_id}}-content" *ngFor="let player of playerSingle?.players_stats; let i = index">
            <div class="player-batting-detail">
              <div class="player-batting-image">
                <div class="player-batting-image-titel"><h3>Batting</h3></div>
                <div class="player-batting-image-icon">
                  <img src="assets/images/batsman.png"> 
                </div>
              </div>
              <div class="player-batting-content">
                <div class="player-batting-content-box">
                  <h4>Matches</h4>
                  <h2>{{player?.matches}}</h2>
                </div>
                <div class="player-batting-content-box">
                  <h4>Highest score</h4>
                  <h2>{{player?.highest_score}}*</h2>
                </div>
                <div class="player-batting-content-box">
                  <h4>50s/100s</h4>
                  <h2>{{player?.half_century}}/{{player?.century}}</h2>
                </div>
                <div class="player-batting-content-box">
                  <h4>Total Runs</h4>
                  <h2>{{player?.total_runs}}</h2>
                </div>
                <div class="player-batting-content-box">
                  <h4>Strike Rate</h4>
                  <h2>{{player?.strike_rate}}</h2>
                </div>
              </div>
            </div>
            <div class="player-bowling-detail">
              <div class="player-bowling-image">
                <div class="player-bowling-image-titel"><h3>Bowling</h3></div>
                <div class="player-bowling-image-icon">
                  <img src="assets/images/bolers-lccc.png">  
                </div>
              </div>
              <div class="player-bowling-content">
                <div class="player-bowling-content-box">
                  <h4>Wickets</h4>
                  <h2>{{player?.wickets}}</h2>
                </div>
                <div class="player-bowling-content-box">
                  <h4>Economy</h4>
                  <h2>{{player?.economy}}</h2>
                </div>
                <div class="player-bowling-content-box">
                  <h4>Stumping</h4>
                  <h2>{{player?.stumping}}</h2>
                </div>
                <div class="player-bowling-content-box">
                  <h4>Average</h4>
                  <h2>{{player?.avg_bowler}}</h2>
                </div>
                <div class="player-bowling-content-box">
                  <h4>Best Bowling Figure</h4>
                  <h2>{{player?.bowling_figures}}</h2>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="player-career-tab-content career-main-content " id="test-cricket-content">
            <div class="player-batting-detail">
              <div class="player-batting-image">
                <div class="player-batting-image-titel"><h3>Batting</h3></div>
                <div class="player-batting-image-icon">
                  <img src="assets/images/batsman.png"> 
                </div>
              </div>
              <div class="player-batting-content">
                <div class="player-batting-content-box">
                  <h4>Matches</h4>
                  <h2>{{playerSingle?.test_matches}}</h2>
                </div>
                <div class="player-batting-content-box">
                  <h4>Highest score</h4>
                  <h2>{{playerSingle?.test_highest_score}}*</h2>
                </div>
                <div class="player-batting-content-box">
                  <h4>50s/100s</h4>
                  <h2>{{playerSingle?.test_half_century}}/{{playerSingle?.test_century}}</h2>
                </div>
                <div class="player-batting-content-box">
                  <h4>Total Runs</h4>
                  <h2>{{playerSingle?.test_total_runs}}</h2>
                </div>
                <div class="player-batting-content-box">
                  <h4>Strike Rate</h4>
                  <h2>{{playerSingle?.test_strike_rate}}</h2>
                </div>
              </div>
            </div>
            <div class="player-bowling-detail">
              <div class="player-bowling-image">
                <div class="player-bowling-image-titel"><h3>Bowling</h3></div>
                <div class="player-bowling-image-icon">
                  <img src="assets/images/bolers-lccc.png">  
                </div>
              </div>
              <div class="player-bowling-content">
                <div class="player-bowling-content-box">
                  <h4>Wickets</h4>
                  <h2>{{playerSingle?.test_wickets}}</h2>
                </div>
                <div class="player-bowling-content-box">
                  <h4>Economy</h4>
                  <h2>{{playerSingle?.test_economy}}</h2>
                </div>
                <div class="player-bowling-content-box">
                  <h4>Strike Rate</h4>
                  <h2>22.13</h2>
                </div>
                <div class="player-bowling-content-box">
                  <h4>Average</h4>
                  <h2>{{playerSingle?.test_avg_bowler}}</h2>
                </div>
                <div class="player-bowling-content-box">
                  <h4>Best Bowling Figure</h4>
                  <h2>{{playerSingle?.test_best_bowling_figures}}</h2>
                </div>
              </div>
            </div>
          </div>
          <div class="player-career-tab-content career-main-content " id="one-day-content">
            <div class="player-batting-detail">
              <div class="player-batting-image">
                <div class="player-batting-image-titel"><h3>Batting</h3></div>
                <div class="player-batting-image-icon">
                  <img src="assets/images/batsman.png"> 
                </div>
              </div>
              <div class="player-batting-content">
                <div class="player-batting-content-box">
                  <h4>Matches</h4>
                  <h2>{{playerSingle?.one_day_matches}}</h2>
                </div>
                <div class="player-batting-content-box">
                  <h4>Highest score</h4>
                  <h2>{{playerSingle?.one_day_highest_score}}*</h2>
                </div>
                <div class="player-batting-content-box">
                  <h4>50s/100s</h4>
                  <h2>{{playerSingle?.one_day_half_century}}/{{playerSingle?.one_day_century}}</h2>
                </div>
                <div class="player-batting-content-box">
                  <h4>Total Runs</h4>
                  <h2>{{playerSingle?.one_day_total_runs}}</h2>
                </div>
                <div class="player-batting-content-box">
                  <h4>Strike Rate</h4>
                  <h2>{{playerSingle?.one_day_strike_rate}}</h2>
                </div>
              </div>
            </div>
            <div class="player-bowling-detail">
              <div class="player-bowling-image">
                <div class="player-bowling-image-titel"><h3>Bowling</h3></div>
                <div class="player-bowling-image-icon">
                  <img src="assets/images/bolers-lccc.png">  
                </div>
              </div>
              <div class="player-bowling-content">
                <div class="player-bowling-content-box">
                  <h4>Wickets</h4>
                  <h2>{{playerSingle?.one_day_wickets}}</h2>
                </div>
                <div class="player-bowling-content-box">
                  <h4>Economy</h4>
                  <h2>{{playerSingle?.one_day_economy}}</h2>
                </div>
                <div class="player-bowling-content-box">
                  <h4>Strike Rate</h4>
                  <h2>22.13</h2>
                </div>
                <div class="player-bowling-content-box">
                  <h4>Average</h4>
                  <h2>{{playerSingle?.one_day_avg_bowler}}</h2>
                </div>
                <div class="player-bowling-content-box">
                  <h4>Best Bowling Figure</h4>
                  <h2>{{playerSingle?.one_day_best_bowling_figures}}</h2>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>     
    </div>
  </div>
</section><!-- page ends-->
